import PropTypes from 'prop-types';
import React     from 'react';

import * as S                from './info-acme.module.scss';
import { SubActionRow }      from '../sub-action-row';
// import { CancelledBox }      from '../../../common/product/cancelled-box';
import { Expiry }            from '../../../common/product/expiry';
import { Price }             from '../../../common/product/price';
import { ProductName }       from '../../../common/product/prod-name';
import { RemainingTime }     from '../../../common/product/remaining-time';
import { TagLine }           from '../../../common/product/tag-line';
// import HAPPY_STAR            from '../../../../assets/imgs/art/happy-star.svg';
// import MEH_STAR              from '../../../../assets/imgs/art/meh-star.svg';
import { useGlobalCtx }      from '../../../../context/ctx-hook';
import * as ProductSelectors from '../../../../context/selectors/product-selectors';
import * as UserSelectors    from '../../../../context/selectors/user-selectors';
// import { isInBetween }       from '../../../../helpers/time-helpers';
import { getSimpPriceWarning }   from '../../../../helpers/skunotices-helpers';
import { getProductLogo } from '../../../../context/selectors/product-selectors';



const InfoAcme = ({product, onClose}) => {
  const {state} = useGlobalCtx();

  const SUB           = ProductSelectors.getSubscription(state, product);
  const HAS_PAYMENT   = UserSelectors.getProductsPaymentMethod(product, state);
  // const IS_HAPPY_STAR = SUB.active && SUB.autoRenew && HAS_PAYMENT;
  // const HISTORY_LIST  = React.useMemo(() => UserSelectors.getUserSubHistory(state, 'acme'), []);
  // const IS_CANCELLED  = React.useMemo(
  //   () =>
  //     !SUB.active || (!SUB.autoRenew && HISTORY_LIST?.filter(({action, createdAt}) =>
  //       (action === 'DISABLE_AUTORENEW' && isInBetween(SUB.effectiveAt, SUB.expireOn, createdAt))
  //     ).length > 0),
  //   [SUB.autoRenew, SUB.effectiveAt, SUB.expireOn, HISTORY_LIST]
  // );
  const { HAS_PRICE_WARNING, NEW_PRICE } = getSimpPriceWarning(SUB.sku, SUB.expireOn, state.featureFlags);


  return (
    <article className={`${S.card} ${S.acmeCard}`}>
      <div className={S.productInfo}>

        <div className={S.leftSide}>
          <div className={S.productHeader}>
            <img alt="square product logo" src={getProductLogo(SUB)} />
            <div className={S.headerText}>
              <ProductName sub={SUB} product='simplifi' className={S.name}/>
              <TagLine uriName={SUB.tierUriName} className={S.tag}/>
              <SubActionRow product={product} onClose={onClose}/>

            </div>
          </div>
        </div>

        <div className={S.rightSide}>
          <Price
            sku={SUB.renewalSku}
            renewalFrequency={SUB.renewalFrequency}
            className={S.priceRow}
            price={HAS_PRICE_WARNING ? NEW_PRICE : false}
          />

          {SUB.isInTrialPeriod && (<div className={S.freeTrial}>Free trial</div>)}
          {(SUB.isInTrialPeriod || !SUB.autoRenew || !HAS_PAYMENT) && <RemainingTime className={S.remainingTime} expireOn={SUB.expireOn} />}
          <Expiry product={product} className={S.infoExpiryRow}/>
        </div>
      </div>
    </article>
  );
};

InfoAcme.displayName = 'InfoAcme';
InfoAcme.propTypes   = {
  product: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};

export { InfoAcme };
